import React, { useState } from 'react';
import { styles } from '../styles/styles';
// Import your lawnmower image
import lawnmowerImage from '../assets/lawnmower.png'; // You'll need to put your image in src/assets/
// Copy icon (Tabler Icons)
import copyIcon from '../assets/contact-icons/copy.svg';
// Customer photos (resized web copies of /customer-photos)
import photo1 from '../assets/customer-photos/img_1553.jpg';
import photo2 from '../assets/customer-photos/img_1638.jpg';
import photo3 from '../assets/customer-photos/img_2477.jpg';
import photo4 from '../assets/customer-photos/img_3020.jpg';
import photo5 from '../assets/customer-photos/img_3098.jpg';
import photo6 from '../assets/customer-photos/img_3186.jpg';

const customerPhotos = [
  { src: photo1, alt: 'Metro Mowing customer lawn 1' },
  { src: photo2, alt: 'Metro Mowing customer lawn 2' },
  { src: photo3, alt: 'Metro Mowing customer lawn 3' },
  { src: photo4, alt: 'Metro Mowing customer lawn 4' },
  { src: photo5, alt: 'Metro Mowing customer lawn 5' },
  { src: photo6, alt: 'Metro Mowing customer lawn 6' }
];

const Hero = () => {
  const [emailCopied, setEmailCopied] = useState(false);

  const copyEmailToClipboard = () => {
    navigator.clipboard.writeText('metro.mowing.fence@gmail.com').then(() => {
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000); // Reset after 2 seconds
    });
  };

  // Animation styles for the lawnmower
  const lawnmowerStyles = {
    container: {
      position: 'relative',
      width: '100%',
      height: '120px',
      overflow: 'hidden',
      marginTop: '3rem',
      zIndex: 1
    },
    lawnmower: {
      position: 'absolute',
      width: '80px',
      height: '80px',
      top: '50%',
      transform: 'translateY(-50%)',
      animation: 'mowAcross 12s linear infinite',
      filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))'
    },
    grassTrail: {
      position: 'absolute',
      top: '70%',
      left: '0',
      width: '100%',
      height: '3px',
      background: 'linear-gradient(to right, transparent, #4CAF50, #8BC34A, transparent)',
      animation: 'fadeTrail 12s linear infinite',
      opacity: 0.6,
      borderRadius: '2px'
    }
  };

  // Updated hero styles
  const heroStylesWithAnimation = {
    ...styles.hero,
    position: 'relative',
    overflow: 'hidden'
  };

  return (
    <>
      {/* CSS Animations */}
      <style>
        {`
          @keyframes mowAcross {
            0% {
              left: -100px;
              opacity: 0;
            }
            5% {
              opacity: 1;
            }
            95% {
              opacity: 1;
            }
            100% {
              left: calc(100% + 100px);
              opacity: 0;
            }
          }

          @keyframes fadeTrail {
            0% {
              opacity: 0;
              transform: scaleX(0);
              transform-origin: left;
            }
            10% {
              opacity: 0.6;
              transform: scaleX(0.1);
            }
            90% {
              opacity: 0.6;
              transform: scaleX(0.9);
            }
            100% {
              opacity: 0;
              transform: scaleX(1);
            }
          }

          .lawnmower-image {
            width: 80px;
            height: 80px;
          }
          
          .mower-container {
            height: 120px;
            margin-top: 3rem;
          }

          .email-button {
            background-color: transparent;
            color: #494eb6;
            padding: 1rem 2rem;
            font-size: 1.1rem;
            font-weight: bold;
            border: 2px solid #494eb6;
            border-radius: 8px;
            cursor: pointer;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            transition: all 0.3s;
            position: relative;
          }

          .email-button:hover {
            background-color: rgba(73, 78, 182, 0.1);
            transform: translateY(-2px);
          }

          .email-button.copied {
            background-color: #4CAF50;
            color: white;
            border-color: #4CAF50;
          }

          .copy-icon {
            width: 20px;
            height: 20px;
            margin-left: 0.5rem;
            filter: invert(37%) sepia(86%) saturate(1000%) hue-rotate(225deg) brightness(95%) contrast(95%);
            transition: filter 0.3s;
          }

          .email-button:hover .copy-icon {
            filter: invert(37%) sepia(86%) saturate(1200%) hue-rotate(225deg) brightness(100%) contrast(100%);
          }

          .email-button.copied .copy-icon {
            filter: invert(1);
          }

          .copy-notification {
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #4CAF50;
            color: white;
            padding: 0.5rem 1rem;
            border-radius: 6px;
            font-size: 0.9rem;
            white-space: nowrap;
            opacity: 0;
            transition: opacity 0.3s;
            pointer-events: none;
          }

          .copy-notification.show {
            opacity: 1;
          }

          @keyframes photoScroll {
            from { transform: translateX(0); }
            to { transform: translateX(-50%); }
          }

          .free-mow-title {
            margin-top: 2.5rem;
          }

          .photo-marquee {
            overflow: hidden;
            margin: 2.5rem -1rem 2.5rem -1rem;
            -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
            mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
          }

          .photo-track {
            display: flex;
            width: max-content;
            animation: photoScroll 40s linear infinite;
          }

          .photo-marquee:hover .photo-track {
            animation-play-state: paused;
          }

          .photo-track img {
            height: 280px;
            width: auto;
            aspect-ratio: 3 / 4;
            object-fit: cover;
            margin-right: 1rem;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            flex-shrink: 0;
          }

          @media (prefers-reduced-motion: reduce) {
            .photo-track {
              animation: none;
            }
            .photo-marquee {
              overflow-x: auto;
            }
          }

          @media (max-width: 768px) {
            .free-mow-title {
              margin-top: 2rem;
            }

            .photo-marquee {
              margin: 2rem -1rem 2rem -1rem;
            }

            .photo-track {
              animation-duration: 30s;
            }

            .photo-track img {
              height: 150px;
              margin-right: 0.6rem;
              border-radius: 8px;
            }

            .lawnmower-image {
              width: 60px !important;
              height: 60px !important;
            }
            
            .mower-container {
              height: 80px !important;
              margin-top: 2rem !important;
            }

            .email-button {
              font-size: 0.9rem !important;
              padding: 0.8rem 1rem !important;
            }

            .copy-notification {
              font-size: 0.8rem !important;
              top: -35px !important;
            }
          }
        `}
      </style>

      <section style={heroStylesWithAnimation}>
        {/* Hero Content */}
        <div style={styles.heroContainer}>
          <div style={styles.heroButtons} className="hero-buttons">
            <a href="tel:6513137009" style={styles.primaryButton}>
              Call Now: (651) 313-7009
            </a>

            {/* Email Copy Button */}
            <button
              onClick={copyEmailToClipboard}
              className={`email-button ${emailCopied ? 'copied' : ''}`}
              style={{ position: 'relative' }}
            >
              {emailCopied ? 'Email Copied!' : (
                <>
                  MetroMowingMN@gmail.com
                  <img
                    src={copyIcon}
                    alt="Copy"
                    className="copy-icon"
                  />
                </>
              )}
              <div className={`copy-notification ${emailCopied ? 'show' : ''}`}>
                Email copied to clipboard!
              </div>
            </button>


            <button
              onClick={() => {
                const isMobile = window.innerWidth <= 768;
                document.getElementById('contact').scrollIntoView({
                  behavior: 'smooth',
                  block: isMobile ? 'center' : 'start'
                });
              }}
              style={styles.secondaryButton}
            >
              Get Free Quote
            </button>
          </div>

          <h2 style={styles.heroTitle} className="hero-title free-mow-title">
            First mow FREE with purchase of Seasonal Package
          </h2>
        </div>

        {/* Scrolling customer photos - list is doubled so the loop is seamless */}
        <div className="photo-marquee">
          <div className="photo-track">
            {[...customerPhotos, ...customerPhotos].map((photo, i) => (
              <img
                key={i}
                src={photo.src}
                alt={i < customerPhotos.length ? photo.alt : ''}
                aria-hidden={i >= customerPhotos.length}
                decoding="async"
              />
            ))}
          </div>
        </div>

        <div style={styles.heroContainer}>
          <p style={styles.heroSubtitle} className="hero-subtitle">
            Transform your property with reliable, professional lawn care services.
            Serving Apple Valley, Rosemount, Eagan, Burnsville, Lakeville and surrounding South Metro areas.
          </p>

          {/* Lawnmower Animation Container */}
          <div style={lawnmowerStyles.container} className="mower-container">
            {/* Lawnmower Image Animation */}
            <img
              src={lawnmowerImage}
              alt="Animated Lawnmower"
              style={lawnmowerStyles.lawnmower}
              className="lawnmower-image"
            />

            {/* Grass Trail */}
            <div style={lawnmowerStyles.grassTrail}></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;